import { SellerType } from 'features/onlinePayment/state/constants';

export const installmentsXfee: Record<string, string> = {
  '1': '1,60%',
  '2': '2,22%',
  '3': '2,94%',
  '4': '2,94%',
  '5': '2,94%',
  '6': '2,94%',
  '7': '3,39%',
  '8': '3,39%',
  '9': '3,39%',
  '10': '3,39%',
  '11': '3,39%',
  '12': '3,39%',
};

export { SellerType };
